import { gql } from '@apollo/client';

export const GET_LIST_ANALYZER_INTEGRATION = gql`
  query GetList($where: Map, $sort: Map, $limit: Int, $offset: Int) {
    GetAnalyzerIntegrationList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on AnalyzerIntegrations {
        data {
          id
          qr_code
          ad_integration_id
          ad_integration {
            ... on AdIntegration {
              id
              ad_id
              currency
              user_socmed_id
              user_socmed {
                ... on SocmedAccount {
                  id
                  team_id
                  type
                  username
                  url
                  account_token
                  active_status
                }
              }
              type
              ad {
                ... on Ad {
                  id
                  ad_set_id
                  ad_set {
                    ... on AdSet {
                      id
                      campaign_id
                      campaign {
                        ... on Campaign {
                          id
                          name
                          start_date
                          end_date
                          budget
                        }
                      }
                      team_id
                      name
                      start_date
                      end_date
                      budget
                      created_at
                      updated_at
                      deleted_at
                    }
                  }
                  team_id
                  team {
                    ... on Team {
                      id
                      name
                      partner
                      limit
                      start_date
                      end_date
                      created_at
                      updated_at
                      deleted_at
                    }
                  }
                  name
                  start_date
                  end_date
                  budget
                  headline
                  promo_code
                  discount_type
                  discount
                  offer
                  content
                  created_at
                  updated_at
                  deleted_at
                }
              }
              socmed_campaign_local
              socmed_campaign_id
              socmed_ad_id
              socmed_adset_id
              socmed_funding_id
              approved_by_id
              approved_by {
                ... on User {
                  id
                  name
                }
              }
              approval_status
              approval_note
              rejection_note
              created_by_id
              created_by {
                ... on User {
                  id
                  name
                }
              }
              created_at
              updated_at
              deleted_at
            }
          }
          ad_analyzer_id
          ad_insight
          type
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;

export const GET_LIST_ANALYZER_INTEGRATION_WITHOUT_SOCMED = gql`
  query GetList($where: Map, $sort: Map, $limit: Int, $offset: Int) {
    GetAnalyzerIntegrationList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on AnalyzerIntegrations {
        data {
          id
          qr_code
          ad_integration_id
          ad_integration {
            ... on AdIntegration {
              id
              ad_id
              user_socmed_id
              user_socmed {
                ... on SocmedAccount {
                  id
                  team_id
                  type
                  username
                  url
                  account_token
                  active_status
                }
              }
              type
              ad {
                ... on Ad {
                  id
                  ad_set_id
                  ad_set {
                    ... on AdSet {
                      id
                      campaign_id
                      campaign {
                        ... on Campaign {
                          id
                          name
                          start_date
                          end_date
                          budget
                        }
                      }
                      team_id
                      name
                      start_date
                      end_date
                      budget
                      created_at
                      updated_at
                      deleted_at
                    }
                  }
                  team_id
                  team {
                    ... on Team {
                      id
                      name
                      partner
                      limit
                      start_date
                      end_date
                      created_at
                      updated_at
                      deleted_at
                    }
                  }
                  name
                  start_date
                  end_date
                  budget
                  headline
                  promo_code
                  discount_type
                  discount
                  offer
                  content
                  created_at
                  updated_at
                  deleted_at
                }
              }
              approved_by_id
              approved_by {
                ... on User {
                  id
                  name
                }
              }
              approval_status
              approval_note
              rejection_note
              created_by_id
              created_by {
                ... on User {
                  id
                  name
                  profile_pic_document_id
                  profile_pic_document {
                    ... on Document {
                      id
                      name
                      object_name
                      bucket_name
                    }
                  }
                }
              }
              created_at
              updated_at
              deleted_at
            }
          }
          ad_analyzer_id
          #ad_insight
          type
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;
